/**
 * French histogram prompts and data titles (ADR 0099 §2). Same shape and the
 * same numbers as the English file. "Combien de" takes no gender, so only the
 * noun changes.
 */
export const histogramPrompts = {
    oneInterval: (noun: string, low: number, high: number, unit: string) =>
        `Combien de ${noun} y a-t-il de ${low} à ${high}${unit} ?`,
    atLeast: (noun: string, low: number, unit: string) => `Combien de ${noun} y a-t-il avec ${low}${unit} ou plus ?`,
    total: (noun: string) => `Combien de ${noun} y a-t-il en tout ?`,
    most: (noun: string) => `Quel intervalle compte le plus de ${noun} ?`,
};

export const histogramContexts: {
    title: string;
    noun: string;
    unit: string;
    width: number;
    starts: number[];
    limit: number;
}[] = [
    { title: 'Notes à un contrôle de mathématiques', noun: 'notes', unit: '', width: 10, starts: [40, 50], limit: 100 },
    { title: "Taille des élèves d'une classe (cm)", noun: 'élèves', unit: ' cm', width: 5, starts: [120, 125, 130], limit: 169 },
    { title: 'Temps pour courir un tour de piste (secondes)', noun: 'chronos', unit: ' secondes', width: 5, starts: [50, 55, 60, 65], limit: 100 },
    { title: 'Âges des personnes à une fête', noun: 'invités', unit: ' ans', width: 5, starts: [5, 10], limit: 49 },
    { title: 'Points marqués à chaque match de basket', noun: 'matchs', unit: ' points', width: 10, starts: [40, 50, 60], limit: 109 },
    { title: 'Distance de chaque saut en longueur (cm)', noun: 'sauts', unit: ' cm', width: 10, starts: [100, 110, 120], limit: 199 },
];
